<template lang="pug">
  include ./../../mixins
  +b.modal
    +b.close(
      slot="top-right"
      @click="$emit('close')"
    )
      +b.I.icon.--type_close
    +e.content
      +b.P.text.--fs_xl.--lh_xs.--color_black.--fw_bold.mb-15 {{ _("Unfortunately, we didn't find your car in our date base.") }}
      +b.P.text.--fs_md.--color_black {{ _("To receive consultation or price estimates please fill in the form") }}
      +e.form
        validation-observer(
          tag="form"
          ref="observer"
          v-slot="props"
          @submit.prevent="validateBeforeSubmit"
        )
          +b.ug-row.--offset_sm
            +b.ug-cell.ug-cols
              validation-provider(
                tag="div"
                v-slot="{errors}"
                name="phone"
                rules="required"
              )
                ui-input(
                  v-model='formdata.phone',
                  type='text',
                  :errors="errors"
                  :label='_("Enter your phone number*")'
                )
            +b.ug-cell.ug-cols
              validation-provider(
                tag="div"
                v-slot="{errors}"
                name="email"
                rules="email"
              )
                ui-input(
                  v-model='formdata.email',
                  type='text',
                  :errors="errors"
                  :label='_("Enter your mail")'
                )
            +b.ug-cell.ug-cols
              validation-provider(
                tag="div"
                v-slot="{errors}"
                name="name"
              )
                ui-input(
                  v-model='formdata.name',
                  type='text',
                  :errors="errors"
                  :label='_("Full Name")'
                )
            validation-provider(
              tag="div"
              v-slot="{errors}"
              name="nonFieldErrors"
            )
              +b.ug-cell.ug-cols
                +b.control.mb-20(v-if="errors[0]")
                  +e.meta
                    +b.SPAN.help.--type_error(:class="{'is-error': errors[0]}") {{ errors[0] }}
            +b.ug-cell.ug-cols
              +b.A.button(@click.prevent="validateBeforeSubmit") {{ _("Send a request") }}
      +b.P.text.--fs_md.--lh_xxs.--color_black
        +b.SPAN.text.--color_black.--fs_md.--lh_xxs {{ _("or contact us directly") }}
      +b.A.phone(:href="'tel:' + _('07501793857')")
        +e.icon
          +b.I.icon.--type_phone
        +e.content
          +b.caption.--size_2.--color_black {{ _("07501793857") }}
</template>

<script>
import mixinValidate from '@/js/mixins/formValidate'
import mixinErrors from '@/js/mixins/showErrors'
import InfoModal from '@/js/components/Modals/InfoModal'
export default {
  props: {
    url: String,
    quoteInfo: {},
  },
  mixins: [
    mixinValidate,
    mixinErrors,
  ],
  data() {
    return {
      formdata: {}
    }
  },
  methods: {
    send() {
      let formdata = Object.assign(this.quoteInfo, this.formdata)
      this.api.post(this.url, formdata).then(res => {
        this.$emit('close')
        this.$modal.show(InfoModal, {
          title: this._("Thansk for request. We will contact you."),
        }, {
          height: 'auto',
          transition: "nice-modal-fade",
          clickToClose: false,
          scrollable: true
        })
      }).catch(error => {
        let {data} = error.response
        this.showErrors(data)
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modals/OrderFail.vue